import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { topProducts } from "../data";

export function TopProducts() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.ecommerce.topProducts}>
      <div className="space-y-3">
        {topProducts.map((product, i) => (
          <div key={product.id} className="flex items-center justify-between rounded-xl bg-card-muted px-4 py-3">
            <div className="flex items-center gap-3">
              <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-soft text-xs font-bold text-primary">
                {i + 1}
              </span>
              <div>
                <p className="text-sm font-medium text-foreground">{product.name}</p>
                <p className="text-xs text-muted">{product.sales} {t.common.sales}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-bold text-foreground">{product.revenue}</p>
              <p className="text-xs font-medium text-green">{product.trend}</p>
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
